import { SearchEntityVersionFragment, SearchEntityVersionsByLocationFragment } from 'types/graphql'

import {
  EntityVersionSearchEntityValue,
  SelectValue,
} from 'src/components/Selects/EntityVersionSearch/types'

export const selectValueEquals = (a: SelectValue, b: SelectValue) => {
  return (
    (typeof a === 'string' && typeof b === 'string' && a === b) ||
    (typeof a !== 'string' && typeof b !== 'string' && a.id === b.id)
  )
}

export const isSelectValueSearchEntityVersionFragment = (
  value: SelectValue
): value is EntityVersionSearchEntityValue => {
  return typeof value !== 'string'
}

export const isSearchEntityVersionFragment = (
  value: EntityVersionSearchEntityValue
): value is SearchEntityVersionFragment => {
  return 'searchableFields' in value || 'intersectingAddresses' in value
}

export const isSearchEntityVersionsByLocationFragment = (
  value: EntityVersionSearchEntityValue
): value is SearchEntityVersionsByLocationFragment => {
  return !isSearchEntityVersionFragment(value)
}
